const FeatureFlag = {
    USE_BUDGET: "USE_BUDGET",
    SEPARATE_PRODUCT: "SEPARATE_PRODUCT",
    CLONE_OBJECTS: "CLONE_OBJECTS",
    STREAMING_LISTS: "STREAMING_LISTS",
    PRE_INSPECTION_BLOCKED_ADD_ORDER: "PRE_INSPECTION_BLOCKED_ADD_ORDER",
    SKU_FIELD_ACTIVE_IN_COLOR_VERSIONS: "SKU_FIELD_ACTIVE_IN_COLOR_VERSIONS",
    DASHLETS: "DASHLETS",
    EDITION_OF_CBM_AND_CARTONS_IN_ORDERS: "EDITION_OF_CBM_AND_CARTONS_IN_ORDERS",
    UPDATE_PRICE_IN_OFFER_AFTER_CHANGE_IN_ORDER_DETAILS: "UPDATE_PRICE_IN_OFFER_AFTER_CHANGE_IN_ORDER_DETAILS",
    LIMITED_CATEGORY_TREE: "LIMITED_CATEGORY_TREE",
    WRITING_DATA_BETWEEN_SEASONS: "WRITING_DATA_BETWEEN_SEASONS",
    AI_GENERATION_AND_VISUALIZATION: "AI_GENERATION_AND_VISUALIZATION",
    GS1_INTEGRATION: "GS1_INTEGRATION",
    PRINT_AS_PDF: "PRINT_AS_PDF",
    ASK_FOR_LANGUAGE_FOR_INQUIRY_DIALOG: "ASK_FOR_LANGUAGE_FOR_INQUIRY_DIALOG",
    OPTIMA_INTEGRATION: "OPTIMA_INTEGRATION",
    GRID_V3: "GRID_V3",
    AI_VIRTUAL_STYLIST: "AI_VIRTUAL_STYLIST",
    BOARD_TEMPLATE: "BOARD_TEMPLATE",
    REPORTS: "REPORTS",
    CONTRACTORS_MARKET: "CONTRACTORS_MARKET",
    SUPPLIERS_MARKET: "SUPPLIERS_MARKET",
    INTEGRATION_VIEWS: "INTEGRATION_VIEWS",
    INSERT_LOGGERS_INTO_INTEGRATION_VIEWS: "INSERT_LOGGERS_INTO_INTEGRATION_VIEWS",
    PRESTASHOP_INTEGRATION: "PRESTASHOP_INTEGRATION",
    CONTRACT_PRINTOUT: "CONTRACT_PRINTOUT",
    SUBIEKT_INTEGRATION: "SUBIEKT_INTEGRATION",
    FILTER_THE_INDEX_BY_PRODUCT_INGREDIENTS: "FILTER_THE_INDEX_BY_PRODUCT_INGREDIENTS",
    MERCHANTS_IN_PRODUCT_IN_SEASON_EDITABLE: "MERCHANTS_IN_PRODUCT_IN_SEASON_EDITABLE",
    DASHLETSCONFIGURATION: "DASHLETSCONFIGURATION",
    MERCHANTS_IN_PRODUCT_IN_SEASON_EDITABLE_REQUIRED: "MERCHANTS_IN_PRODUCT_IN_SEASON_EDITABLE_REQUIRED",
    SHOW_ALL_EXPORT_DYNAMIC_ATTRIBUTES_BUTTON: "SHOW_ALL_EXPORT_DYNAMIC_ATTRIBUTES_BUTTON",
    AUTOMATIC_CALCULATION_OF_QUANTITY_ON_PRODUCT_IN_SEASON: "AUTOMATIC_CALCULATION_OF_QUANTITY_ON_PRODUCT_IN_SEASON",
    GET_STARTED_WELCOME_GUIDS: "GET_STARTED_WELCOME_GUIDS",
    ENABLE_TO_EDIT_QUANTITY_ON_PRODUCT_IN_SEASON: "ENABLE_TO_EDIT_QUANTITY_ON_PRODUCT_IN_SEASON",
    SHIPMENT_SAMPLE_ADD_MODE_ENABLED: "SHIPMENT_SAMPLE_ADD_MODE_ENABLED",
    PP_SAMPLE_ADD_MODE_ENABLED: "PP_SAMPLE_ADD_MODE_ENABLED",
    INTEGRATION_WITH_SHIPSGO: "INTEGRATION_WITH_SHIPSGO",
    ENABLED_GRID_LINKS: "ENABLED_GRID_LINKS",
}

export default FeatureFlag;